import { makeStyles } from "@material-ui/core";
import { white, error } from "../../../../constants/colors";

const useStyles = makeStyles(({ breakpoints: { down } }) => ({
  addNewBtn: {
    transition: "all 0.3s ease",
    background: "rgb(74 148 236 / 10%)",
    borderRadius: "10px",
    color: "#4A94EC",
    height: "64px",
    fontSize: "10px",
    "& h6": {
      fontFamily: "sbcBold",
    },

    "&:hover": {
      boxShadow: "0px 3px 14px rgba(0, 0, 0, 0.15)",
      cursor: "pointer",
    },

    [down("xs")]: {
      minWidth: "130px",
      flexDirection: "column",
      "& >div": {
        marginBottom: "8px",
      },
    },
  },
  footerLogo: {
    background: white,
    borderRadius: "10px",
    padding: "16px 20px",
  },
  removeCard: {
    transition: "all 0.3s ease",
    background: "rgb(235 87 87 / 10%)",
    borderRadius: "10px",
    color: error,
    height: "64px",
    fontSize: "10px",
    "& h6": {
      fontFamily: "sbcBold",
      textTransform: "uppercase",
    },

    "&:hover": {
      boxShadow: "0px 3px 14px rgba(0, 0, 0, 0.15)",
      cursor: "pointer",
    },

    [down("xs")]: {
      minWidth: "130px",
      flexDirection: "column",
      "& >div": {
        marginBottom: "8px",
      },
    },
  },
}));

export default useStyles;
